import CountdownCircle from "./CountdownCircle"
import { compose } from "recompose"

CountdownCircle.defaultProps= {
  angle: 241,
  bgColor: "#4da5da",
  sectorColor: "#4e4d4e"
}

export default compose()(CountdownCircle)